// extracted by mini-css-extract-plugin
module.exports = {"headerHeight":"80px","Grid":"collection-list_Grid__wPJsq"};